import {DataFetcher} from '@aboutyou/data-fetcher';
import {PriceAndBrandSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {COLORS, Image} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useComputeDefaultState} from '../PriceAndBrand/utils';
import {usePriceAndBrandSection} from '../useGetProductBulkSection';

interface ProductBustThumbnailQuickViewProps {
  className?: string;
}

const ProductBustThumbnailQuickViewView: React.FC<
  ProductBustThumbnailQuickViewProps & PriceAndBrandSection
> = ({product, className}) => {
  const {t} = useTranslation();
  const image = product.primaryBustImage;

  return (
    <ThumbnailWrapper className={className} aria-hidden={!image?.src}>
      {image?.src && (
        <ThumbnailImage
          src={image.src}
          alt={image.description || t('Product image')}
          loading="lazy"
          breakpoints={[{width: '40px'}]}
          widths={[80, 120]}
          ratio="3:4"
          disableFixedRatio
        />
      )}
    </ThumbnailWrapper>
  );
};

export const ProductBustThumbnailQuickView: React.FC<
  ProductBustThumbnailQuickViewProps
> = props => {
  const defaultState = useComputeDefaultState();

  return (
    <DataFetcher
      request={usePriceAndBrandSection()}
      Error={null}
      Loading={() => <ThumbnailWrapper className={props.className} />}
      viewProps={props}
      View={ProductBustThumbnailQuickViewView}
      computeDefaultState={() => defaultState}
    />
  );
};

const ThumbnailWrapper = styled.div`
  width: 40px;
  height: 54px;
  flex-shrink: 0;
  align-self: flex-start;
  box-sizing: border-box;
  padding: 5px 4px;
  border-radius: 4px;
  background: ${COLORS.ProductImageBackground};
`;

const ThumbnailImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  display: block;
`;
